import * as React from 'react'

import { observer } from 'mobx-react'

import PermitListItem from '~/client/src/shared/components/PermitListItem'
import Workflow from '~/client/src/shared/models/Workflow'

import MapViewItemBase from '../../SitemapHelpers/models/MapViewItemBase'
import SitemapDraggableModalWrapper from '../SitemapDraggableModalWrapper'

interface IProps {
  item: MapViewItemBase
  containerRef: HTMLElement
  selectedSitePermits: Workflow[]
  selectedPermitId: string
  topOffset: number
  leftOffset: number

  openPermit(permit: Workflow): void
  onClose(): void
}

// localization: no text to translate

@observer
export default class SitemapPermitsDraggableModal extends React.Component<IProps> {
  public render() {
    const {
      item,
      containerRef,
      selectedSitePermits = [],
      selectedPermitId,
      openPermit,
      onClose,
      topOffset,
      leftOffset,
    } = this.props

    if (!selectedSitePermits.length) {
      return
    }

    return (
      <SitemapDraggableModalWrapper
        className="overflow-auto"
        item={item}
        containerRef={containerRef}
        onClose={onClose}
        topOffset={topOffset}
        leftOffset={leftOffset}
      >
        <div className="relative overflow-auto draggable-elements-list">
          {selectedSitePermits.map(permit => (
            <PermitListItem
              key={permit.id}
              permit={permit}
              onClick={openPermit}
              isSelected={permit.id === selectedPermitId}
            />
          ))}
        </div>
      </SitemapDraggableModalWrapper>
    )
  }
}
